<template>
  <div class="main_profile_wrapper">
    <UserPattern :userScore="userScore"></UserPattern>
    <div class="main_table">
      <TableHeaderSection
        @toggleModal="ToggleTaskModal('add')"
        :title="`${localization('In School Tasks')}`"
        :text="`${localization('Manage and edit your tasks or add new ones.')}`"
        :buttonText="`${localization('Add new task')}`"
        :total="$store.getters['user/tasks_count']"
      ></TableHeaderSection>
      <div class="header_container just_custom_table_tasks">
        <CustomTable
          :count="$store.getters['user/tasks_count']"
          :DataItems="tasks"
          @Refresh="refresh"
          @reset="filter = {}"
          :filter="filter"
          hidden_export_import
          admin_permission="admin_tasks"
          edit_permission="add_tasks"
          @selection="selections"
          :empty-state-title="`${localization('No tasks founded')}`"
          :empty-state-text="`${localization('Your search did not match any task. Please Check your inputs and try again.')}`"
          :empty-state-image="require('@/assets/new-theme/empty-state.png')"
          :show-default-empty-actions="false"
          @reset-filters="filter = {}"
          @toggleModal="ToggleTaskModal('add')"
        >
          <template #filter>
            <el-select
              v-model="filter.topic_id"
              clearable
              :placeholder="`${localization('Topic - All')}`"
              class="select_filter_custom"
            >
              <el-option
                v-for="(option, index) in combineTopics()"
                :key="index"
                :label="option.name"
                :value="option.id"
              ></el-option>
            </el-select>
          </template>
          <template #columns>
            <el-table-column type="selection" width="80"></el-table-column>
            <el-table-column
              prop="name"
              :label="`${localization('Name')}`"
              sortable
              :sort-method="caseInsensitiveSort"
            >
            </el-table-column>
            <el-table-column
              prop="topic_name"
              :label="`${localization('Topic')}`"
              class-name="d-none d-md-table-cell"
              label-class-name="d-none d-md-table-cell"
              sortable
              :sort-method="caseInsensitiveSort"
            ></el-table-column>
            <el-table-column
              prop=""
              :label="`${localization('Selected Strategies')}`"
              min-width="100"
              width="auto"
            >
              <template slot-scope="scope">
                <div class="main_custom_parts_pattern">
                  <div class="part_pattern s">
                    <span>S</span>
                    <span>-</span>
                    <span>{{
                      scope.row.selected_strategies_count.Sequence
                        ? scope.row.selected_strategies_count.Sequence
                        : 0
                    }}</span>
                  </div>
                  <div class="part_pattern p">
                    <span>P</span>
                    <span>-</span>
                    <span>{{
                      scope.row.selected_strategies_count.Precision
                        ? scope.row.selected_strategies_count.Precision
                        : 0
                    }}</span>
                  </div>
                  <div class="part_pattern t">
                    <span>T</span>
                    <span>-</span>
                    <span>{{
                      scope.row.selected_strategies_count["Technical Reasoning"]
                        ? scope.row.selected_strategies_count[
                            "Technical Reasoning"
                          ]
                        : 0
                    }}</span>
                  </div>
                  <div class="part_pattern c">
                    <span>C</span>
                    <span>-</span>
                    <span>{{
                      scope.row.selected_strategies_count.Confluence
                        ? scope.row.selected_strategies_count.Confluence
                        : 0
                    }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="" label="">
              <template slot-scope="scope">
                <div class="td_actions flex justify-content-end">
                  <router-link
                    v-if="hasPermission('show_tasks')"
                    :to="`/new-theme/tasks/${scope.row.id}`"
                    v-tooltip.top-center="
                      `${localization('Show Task')}`
                    "
                    class="btn btn-info btn-link btn-xs"
                  >
                    <img
                      src="@/assets/new-theme/eye-inactive.png"
                      alt="eye-inactive"
                    />
                  </router-link>
                  <a
                    v-if="hasPermission('edit_tasks')"
                    v-tooltip.top-center="
                      `${localization('Edit Task')}`
                    "
                    class="btn btn-warning btn-simple btn-link"
                    @click="ToggleTaskModalForEdit('edit', scope.row)"
                  >
                    <img
                      src="@/assets/new-theme/edit-05-inactive.png"
                      alt="edit-05-inactive"
                    />
                  </a>
                  <!-- <span class="btn btn-warning btn-simple btn-link">
                    <img
                      src="@/assets/new-theme/printer-inactive.png"
                      alt="printer-inactive"
                    />
                  </span> -->
                </div>
              </template>
            </el-table-column>
          </template>
          <template #empty-actions>
            <button class="empty_state_button" @click="resetFilters">
              {{localization('Clear Search')}}
            </button>
            <AppButton
              @click="ToggleTaskModal('add')"
              :text="`${localization('Add new task')}`"
            ></AppButton>
          </template>
        </CustomTable>
        <DeleteTasks
          v-if="selected.length > 0"
          :text="`${selected.length} tasks selected`"
          @close="resetSelections"
          @print="printTasks"
          @delete="deleteTasks"
        ></DeleteTasks>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="600px"
      top="1%"
      custom-class="task-modal global_modal"
      @close="resetForm"
      :close-on-click-modal="false"
    >
      <div class="custom_modal_header">
        <div class="images">
          <img src="@/assets/new-theme/file.png" alt="file" />
          <img
            @click="resetForm"
            class="close_img"
            src="@/assets/new-theme/x-close-modal.png"
            alt="file"
          />
        </div>
        <h3 class="title">
          {{ type == "add" ? localization("Add a new study-related task") : localization("Edit your study-related task") }}
        </h3>
        <p class="description">
          {{localization('Add your own task and discover what patterns are needed to successfully complete it.')}}
        </p>
      </div>
      <el-form :model="task" :rules="rules" ref="taskForm" class="task-form">
        <div class="flex justify-content-between" style="gap: 10px">
          <div class="flex-grow-1">
            <el-form-item prop="name">
              <AppInputLabel :text="`${localization('Name your task')}`" :star="true"></AppInputLabel>
              <el-input
                class="new_theme_custom_input"
                v-model="task.name"
                :placeholder="`${localization('Give your task a name')}`"
                clearable
              ></el-input>
            </el-form-item>
          </div>
          <div class="flex-grow-1">
            <el-form-item prop="topic_id">
              <AppInputLabel :text="`${localization('Task category')}`" :star="true"></AppInputLabel>
              <el-select
                v-model="task.topic_id"
                clearable
                :placeholder="`${localization('Topic')}`"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in standardTopicsData"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <el-form-item prop="description">
          <AppInputLabel :text="`${localization('Task description')}`" :star="true"></AppInputLabel>
          <el-input
            class="new_theme_custom_input input_with_custom_text_area"
            type="textarea"
            v-model="task.description"
            :placeholder="`${localization('Add task description')}`"
            clearable
          />
        </el-form-item>
      </el-form>
      <div class="or_modal mb-3">
        {{ localization("or") }}
      </div>
      <div class="file-upload">
        <el-upload
          class="upload-demo"
          drag
          action=""
          :on-change="handleUploadSuccess"
          :before-upload="beforeUpload"
          :file-list="fileList"
          :auto-upload="false"
          :on-remove="handleRemove"
          :show-file-list="false"
          accept="image/apng, image/jpeg, image/png, image/webp,application/pdf"
          :disabled="loading"
        >
          <div v-if="!loading">
            <img src="@/assets/new-theme/upload.png" alt="upload" />
            <div class="el-upload__text">
              <span class="click_upload">
                {{ localization("Click to upload") }}
                </span>
                {{ localization("or drag and drop") }}
            </div>
            <div class="el-upload__tip">
              {{ localization("Supported") }}: PNG, JPG, pdf (Max 5MB)
            </div>
          </div>
          <div
            class="d-flex spin_modal"
            v-loading="loading"
            element-loading-text="waiting to extract photo..."
          ></div>
        </el-upload>
      </div>
      <div v-if="fileList && fileList.length > 0" class="uploaded-files">
        <ul>
          <li v-for="file in fileList" :key="file.name" class="file-item">
            <div class="d-flex" style="gap: 10px">
              <div>
                <img src="../../../assets/new-theme/file.png" alt="" />
              </div>
              <div>
                <span class="file-name">{{ file.name }}</span>
                <span class="d-block file_size"
                  >{{ (file.size / 1024).toFixed(2) }} KB</span
                >
              </div>
            </div>
            <i class="el-icon-delete file-delete" @click="removeFile(file)"></i>
          </li>
        </ul>
      </div>
      <div class="lci_modal_buttons mt-4">
        <button @click="resetForm" class="lci_btn_modal_cancel ">
          {{ localization("Cancel") }}
        </button>
        <button @click="submitForm" class="lci_btn save  lci_btn_modal_cancel">
          {{ localization("Confirm") }}
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  name: "TasksView",

  data() {
    return {
      showAddTask: false,
      dialogVisible: false,
      taskTypes: ["Study-related task", "Work-related task"],
      task: {
        name: "",
        topic_id: "",
        description: ""
      },
      fileList: [],
      rules: {
        name: [
          {
            required: true,
            message: this.localization("Please enter the task name"),
            trigger: "blur"
          }
        ],
        topic_id: [
          {
            required: true,
            message: this.localization("Please enter the task topic"),
            trigger: "blur"
          }
        ],
        description: [
          {
            required: true,
            message: this.localization("Please enter a task description"),
            trigger: "blur"
          }
        ]
      },
      filter: {},
      selected: [],
      loading: false,
      task_id: null,
      tasks: null,
      type: ""
    };
  },
  computed: {
    mainUserId() {
      return this.$route.params.id ? this.$route.params.id : this.auth().id;
    },
    userScore() {
      return this.$store.getters["user/score"];
    },
    userData() {
      return this.$store.state.user.user;
    },
    image() {
      if (this.userData.image) {
        return `${process.env.VUE_APP_BASE_URL}/users/photo/${this.userData.image}`;
      }
      return "/static/img/lml-swerl.jpg";
    },
    standardTopicsData() {
      return this.$store.getters["topics/getStandardTopics"];
    },
    defaultTopicsData() {
      return this.$store.getters["topics/getDefaultTopics"];
    }
  },
  methods: {
    combineTopics(){
      const standardTopics = this.standardTopicsData || [];
      const defaultTopics = this.defaultTopicsData || [];

      return [...standardTopics, ...defaultTopics];
    },
    getMainUserData() {
      this.$store.dispatch("user/user", this.mainUserId)
      if (this.userData.invalid_score != null) {
        this.$router.push("/new-theme/instructions");
      }
      // if(this.userData.sequence){
      //   }else {
      //     this.$router.push( '/new-theme/instructions' )
      //   }
    },
    getProgressColor(key) {
      switch (key) {
        case "Precision":
          return "#3c3";
        case "Technical Reasoning":
          return "#f93";
        case "Confluence":
          return "#c36";
        case "Sequence":
          return "#39c";
      }
    },
    resetFilters(){
      this.filter = {};
      this.$router.go();
    },
    ToggleTaskModal(type) {
      this.task= {
        name: "",
        topic_id: "",
        description: ""
      },
      this.showAddTask = !this.showAddTask;
      this.dialogVisible = !this.dialogVisible;
      this.type = type;
    },
    ToggleTaskModalForEdit(type, taskData) {
      this.type = type;
      this.task_id = taskData.id;
      this.task.name = taskData.name;
      this.task.description = taskData.description;
      this.task.topic_id = taskData.topic_id;
      this.dialogVisible = !this.dialogVisible;
    },
    refresh(query) {
      this.$store
        .dispatch("user/userTask", { id: this.mainUserId, query: query })
        .then((res) => {
          this.tasks = res.tasks;
          this.$store.dispatch("topics/GetTopics", { query: null });
        });
      this.$store.dispatch("topics/handlerStandardTopics");
      this.$store.dispatch("topics/handlerDefaultTopics");
    },
    selections(selections) {
      this.selected = Array.from(selections, el => el.id);
    },
    resetSelections() {
      this.selected = [];
      this.$refs.customTable.clearSelection();
    },
    handleUploadSuccess(file, fileList) {
      this.fileList = fileList;
      this.handle_upload_file_img(file);
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("File size cannot exceed 5MB.");
      }
      return isLt5M;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
    },
    removeFile(file) {
      const index = this.fileList.indexOf(file);
      if (index !== -1) {
        this.fileList.splice(index, 1);
      }
    },
    handle_upload_file_img(file) {
      this.loading = true;
      this.description_photo = file.raw;
      let payload = new FormData();
      payload.append("photo", file.raw);
      this.$store
        .dispatch("user/get_ocr_photo_description", payload)
        .then(response => {
          this.task.description = response.photo_description;
          this.loading = false;
          Swal.fire({
            title: "",
            icon: "success",
            text: `${this.localization("Please double check the extracted text!")}`,
            type: "success",
            confirmButtonText: `${this.localization("Ok")}`,
            confirmButtonClass: "btn btn-success ",
            buttonsStyling: false
          });
        });
      this.fileList = [];
      this.loading = false;
    },
    submitForm() {
      this.$refs.taskForm.validate(valid => {
        if (valid) {
          if (this.type == "add") {
            this.$store
              .dispatch("user/add_task", {
                query: this.task
              })
              .then(response => {
                this.dialogVisible = false;

                Swal.fire({
                  title: "",
                  icon: "success",
                  text: `${this.localization("Done")}`,
                  confirmButtonText: `${this.localization("Ok")}`,
                  type: "success",
                  confirmButtonClass: "btn btn-success ",
                  buttonsStyling: false
                });
                this.refresh({});
                this.$router.push(`/new-theme/tasks/${response.task.id}`);
              })
              .catch(_ => {
                this.dialogVisible = false;
              });
          } else {
            this.$store
              .dispatch("user/edit_task", {
                query: this.task,
                id: this.task_id
              })
              .then(_ => {
                this.dialogVisible = false;

                Swal.fire({
                  title: "",
                  icon: "success",
                  text: `${this.localization("Done")}`,
                  confirmButtonText: `${this.localization("Ok")}`,
                  type: "success",
                  confirmButtonClass: "btn btn-success ",
                  buttonsStyling: false
                });

                this.refresh({});
                this.$router.push(`/new-theme/tasks/${this.task_id}`);
              })
              .catch(_ => {
                this.dialogVisible = false;
              });
          }
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.taskForm.resetFields();
      this.fileList = [];
      this.dialogVisible = false;
    },
    printTasks() {
      let payload = {
        tasks: this.selected
      };
      this.$store.dispatch("tasks/handlePrintSchoolTasks", payload).then(() => {
        window.print();
        this.refresh();
      });
    },
    deleteTasks() {
      Swal.fire({
        title: "",
        text: `${this.localization("Are You Sure")}`,
        type: "warning",
        icon: "error",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success ",
        cancelButtonClass: "btn btn-danger ",
        confirmButtonText: `${this.localization("Delete")}`,
        cancelButtonText: `${this.localization("Cancel")}`,
        buttonsStyling: false
      }).then(date => {
        if (date.isConfirmed) {
          let payload = {
            tasks: this.selected
          };
          this.$store.dispatch("tasks/handleDeleteTasks", payload).then(_ => {
            this.refresh(null);
            Swal.fire({
              title: "",
              icon: "success",
              type: "success",
              text: `${this.localization("Deleted")}`,
              confirmButtonText: `${this.localization("Ok")}`,
              confirmButtonClass: "btn btn-success ",
              buttonsStyling: false
            });
          });
        }
      });
    },
    caseInsensitiveSort(a, b) {
      return a.name.localeCompare(b.name, 'en', { sensitivity: 'base' });
    }
  },
  mounted() {
    this.getMainUserData();
    this.refresh();
  }
};
</script>

<style lang="scss" scoped>
.main_custom_parts_pattern {
  display: flex;
  justify-content: space-between;
  gap: 5px;
  align-items: center;
  .part_pattern {
    border: 1px solid;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    border-radius: 16px;
    height: 25px;
    padding: 10px 13px;
    width: 55px;
    font-weight: 500;
    &.s {
      color: #39c;
      border-color: #39c;
    }
    &.p {
      color: #3c3;
      border-color: #3c3;
    }
    &.t {
      color: #f93;
      border-color: #f93;
    }
    &.c {
      color: #c36;
      border-color: #c36;
    }
  }

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 4px;
    justify-content: flex-start;

    .part_pattern {
      width: 48px;
      padding: 4px 8px;
      font-size: 12px;
      height: 22px;
    }
  }
}
.text {
  color: #667085;
  font-weight: 400;
  font-size: 16px;
}
.main_profile_wrapper {
  background: #fff;
  width: 100%;
  max-width: 100%;
  padding: 0 30px 50px;
}
.main_title {
  color: #101828;
  font-weight: 600;
  font-size: 20px;
  &.white_text {
    color: #fff;
  }
}
.padding {
  padding: 14px;
}
.main_table {
  margin-top: 30px;
  border-radius: 8px;
  border: 1px solid #eaecf0;

  .head_table {
    border-bottom: 1px solid #eaecf0;
  }
}
</style>

<style scoped>
.task-type {
  margin-bottom: 20px;
}
.task-form {
  margin-bottom: 20px;
}
.file-upload {
  margin-bottom: 20px;
  text-align: center;
}

.el-upload {
  border: 2px dashed #d9d9d9;
  padding: 20px;
  border-radius: 8px;
  width: 100%;
}
::v-deep .input_with_custom_text_area .el-textarea__inner {
  word-break: break-word !important; /* Ensures long words break */
  overflow-wrap: break-word !important; /* Ensures text wraps properly */
  white-space: pre-wrap !important; /* Preserves line breaks */
}
</style>
